import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  min-width: 0;
  height: 100%;
}

.app-shell {
  height: 100vh;
  height: 100dvh;
}

.app-content-scroll {
  overscroll-behavior-y: contain;
  scroll-padding-bottom: max(24px, env(safe-area-inset-bottom));
}

@media (max-width: 1023px) {
  .mobile-app-header {
    box-sizing: content-box;
    padding-top: env(safe-area-inset-top);
  }
  .mobile-sidebar-panel {
    width: min(17.5rem, 100vw - 3.5rem);
  }
  .mobile-sidebar-content {
    padding-top: env(safe-area-inset-top);
    padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
  }
  .mobile-sidebar-close {
    padding-top: max(1.25rem, env(safe-area-inset-top) + 0.75rem);
  }
  .app-content-scroll {
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .push-permission-prompt {
    bottom: max(1rem, env(safe-area-inset-bottom));
  }
}`],
})
export class LayoutSidebarComponent implements OnInit {
    public pushPromptVisible: boolean = false;
    public pushPromptState: string = 'ready';
    public pushPromptMessage: string = '';
    public pushPromptBusy: boolean = false;
    private pushPublicKey: string = '';
    private pushRegistration: ServiceWorkerRegistration | null = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.status.toggle('navbar', false);
        await this.initializePushPrompt();
        await this.service.render();
    }

    private isStandalone() {
        const nav: any = navigator;
        return (
            window.matchMedia('(display-mode: standalone)').matches
            || nav.standalone === true
        );
    }

    private async pushApi(action: string, params: any = {}) {
        try {
            const body = new URLSearchParams();
            Object.keys(params).forEach((key) => {
                body.set(key, String(params[key] ?? ''));
            });
            const response = await fetch(
                `/wiz/api/component.nav.sidebar/${action}`,
                {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': (
                            'application/x-www-form-urlencoded;charset=UTF-8'
                        )
                    },
                    body: body.toString()
                }
            );
            return await response.json();
        } catch (error) {
            return { code: 0, data: {} };
        }
    }

    private async loadPushPublicKey() {
        const response = await this.pushApi('push_config');
        if (
            response.code === 200
            && response.data?.enabled
            && response.data?.public_key
        ) {
            return response.data.public_key;
        }

        const workerResponse = await fetch('/sw.js', { cache: 'no-store' });
        if (!workerResponse.ok) return '';
        const workerSource = await workerResponse.text();
        const match = workerSource.match(
            /MOATIME_VAPID_PUBLIC_KEY\s*=\s*['"]([^'"]+)['"]/
        );
        return match?.[1] || '';
    }

    private urlBase64ToUint8Array(value: string) {
        const padding = '='.repeat((4 - value.length % 4) % 4);
        const base64 = (value + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        const raw = window.atob(base64);
        return Uint8Array.from(
            Array.from(raw).map((character) => character.charCodeAt(0))
        );
    }

    private async syncPushSubscription(subscription: PushSubscription) {
        const serialized: any = subscription.toJSON();
        const response = await this.pushApi('subscribe_push', {
            endpoint: serialized.endpoint || subscription.endpoint,
            p256dh: serialized.keys?.p256dh || '',
            auth: serialized.keys?.auth || '',
            user_agent: navigator.userAgent
        });
        if (response.code === 200 && response.data?.subscribed) {
            localStorage.removeItem('moatime-push-sync-pending');
        } else {
            localStorage.setItem('moatime-push-sync-pending', '1');
        }
    }

    private promptWasRecentlyDismissed() {
        const dismissedAt = Number(
            localStorage.getItem('moatime-push-prompt-dismissed-at') || 0
        );
        const threeDays = 3 * 24 * 60 * 60 * 1000;
        return dismissedAt > 0 && Date.now() - dismissedAt < threeDays;
    }

    private async initializePushPrompt() {
        if (
            !this.isStandalone()
            || !('serviceWorker' in navigator)
            || !('PushManager' in window)
            || !('Notification' in window)
        ) {
            return;
        }

        try {
            this.pushPublicKey = await this.loadPushPublicKey();
            if (!this.pushPublicKey) return;
            this.pushRegistration = await navigator.serviceWorker.register(
                '/sw.js',
                { scope: '/' }
            );
            const subscription = await this.pushRegistration.pushManager
                .getSubscription();
            if (subscription) {
                await this.syncPushSubscription(subscription);
                return;
            }
            if (
                Notification.permission !== 'denied'
                && !this.promptWasRecentlyDismissed()
            ) {
                this.pushPromptState = 'ready';
                this.pushPromptMessage = (
                    '알림을 켜면 기기 설정의 알림 목록에 '
                    + 'MoaTime이 표시됩니다.'
                );
                this.pushPromptVisible = true;
            }
        } catch (error) {
            this.pushPromptVisible = false;
        }
    }

    public async enablePushNotifications(event: Event) {
        event.stopPropagation();
        if (this.pushPromptBusy) return;
        this.pushPromptBusy = true;

        try {
            const permission = await Notification.requestPermission();
            if (permission !== 'granted') {
                this.pushPromptState = 'denied';
                this.pushPromptMessage = (
                    '알림이 허용되지 않았습니다. MoaTime 앱의 '
                    + '기기 설정에서 알림을 허용해주세요.'
                );
                return;
            }
            if (!this.pushRegistration) {
                this.pushRegistration = await navigator.serviceWorker.register(
                    '/sw.js',
                    { scope: '/' }
                );
            }
            let subscription = await this.pushRegistration.pushManager
                .getSubscription();
            if (!subscription) {
                subscription = await this.pushRegistration.pushManager
                    .subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: this.urlBase64ToUint8Array(
                            this.pushPublicKey
                        )
                    });
            }
            await this.syncPushSubscription(subscription);
            localStorage.removeItem('moatime-push-prompt-dismissed-at');
            this.pushPromptState = 'success';
            this.pushPromptMessage = (
                '알림이 켜졌습니다. 이제 기기 설정의 알림 목록에서 '
                + 'MoaTime을 확인할 수 있습니다.'
            );
        } catch (error) {
            this.pushPromptState = 'error';
            this.pushPromptMessage = (
                '알림을 켜지 못했습니다. 앱을 완전히 종료한 뒤 '
                + '다시 시도해주세요.'
            );
        } finally {
            this.pushPromptBusy = false;
            await this.service.render();
        }
    }

    public async closePushPrompt(event: Event) {
        event.stopPropagation();
        if (this.pushPromptState === 'ready') {
            localStorage.setItem(
                'moatime-push-prompt-dismissed-at',
                String(Date.now())
            );
        }
        this.pushPromptVisible = false;
        await this.service.render();
    }

    public openMobileMenu(event: Event) {
        event.stopPropagation();
        this.service.status.toggle('navbar', true);
    }

    public closeMobileMenu(event?: Event) {
        event?.stopPropagation();
        this.service.status.toggle('navbar', false);
    }

    @HostListener('document:keydown.escape')
    public escape() {
        this.closeMobileMenu();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }
}

export default LayoutSidebarComponent;